import { Moment } from '@chipinside/frontend'
import { Translate } from '@chipinside/translate'
import { Tooltip } from '@mui/material'
import React, { CSSProperties, PropsWithChildren } from 'react'

import { Icon } from '#/components/Icon'
import { OutdatedRule, outdatedRules, verifyIfOutdated } from '#/components/OutdatedData/rules'

type Props = {
  rules?: OutdatedRule[]
  timestamp?: string
  style?: CSSProperties
  allowTooltip?: boolean
} & PropsWithChildren

export function OutdatedData({
  allowTooltip = true,
  children,
  rules = outdatedRules.monitoring,
  style,
  timestamp,
}: Props) {
  if (!children || !timestamp) return children

  const formattedDate = Moment.view(timestamp)

  let tooltip: React.ReactNode = Translate({
    messageKey: 'data_from_date',
    params: { date: formattedDate },
  })

  const outdatedRule = verifyIfOutdated({ rules, timestamp })

  const { asterisk, getTooltip, hideValue } = outdatedRule ?? {}

  children = hideValue ? undefined : children
  style = hideValue ? undefined : style
  tooltip = getTooltip ? getTooltip(Moment.view(timestamp)) : tooltip

  if (asterisk) {
    children = (
      <div style={{ alignItems: 'center', display: 'flex', gap: '5px', ...style }}>
        {children}
        {<Icon size="large" name="asterisk" style={{ fontSize: '10px' }} />}
      </div>
    )
  }

  if (tooltip && allowTooltip) {
    // div para o tooltip funcionar direito... (-.-)
    return (
      <Tooltip title={tooltip}>
        <div style={style}>{children as React.ReactElement}</div>
      </Tooltip>
    )
  }

  return children
}
